/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormRiskEntry } from '../../models/form-risk-entry';
import { FormRiskEntryBulkUpdateDto } from '../../models/form-risk-entry-bulk-update-dto';

export interface UpdateBulk$Params {
  formId: string;
  body: FormRiskEntryBulkUpdateDto;
}

export function updateBulk(
  http: HttpClient,
  rootUrl: string,
  params: UpdateBulk$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormRiskEntry>>> {
  const rb = new RequestBuilder(rootUrl, updateBulk.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormRiskEntry>>;
    })
  );
}

updateBulk.PATH = '/forms/{formId}/risk-entry/bulk';
